export default __webpack_public_path__ + "static/media/Immutability.b4791621.png";